import { render, staticRenderFns } from "./DetailOrder.vue?vue&type=template&id=7783b62f&"
import script from "./DetailOrder.vue?vue&type=script&lang=js&"
export * from "./DetailOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports